export interface IPaymentSearchByStatementCriteria {
    organizationName: string;
    eventTimeFromUtc:Date;
    eventTimeToUtc:Date;
    eventTimeFromLocal: Date;
    eventTimeToLocal: Date;

}


export class PaymentSearchByStatementSearchCriteria implements IPaymentSearchByStatementCriteria {
    organizationName: string;
    eventTimeFromUtc:Date;
    eventTimeToUtc:Date;
    eventTimeFromLocal: Date;
    eventTimeToLocal: Date;
}